import { render } from "./providerGarmentProductionsTable.vue?vue&type=template&id=6abe87ce&scoped=true&ts=true"
import script from "./providerGarmentProductionsTable.vue?vue&type=script&lang=ts"
export * from "./providerGarmentProductionsTable.vue?vue&type=script&lang=ts"

import "./providerGarmentProductionsTable.vue?vue&type=style&index=0&id=6abe87ce&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abe87ce"]])

export default __exports__